import { createSelector } from '@ngrx/store';

import { invoiceFeature } from '../reducer/invoice.reducer';

export const {
  selectSurveys,
  selectError,
  selectLoading,
  selectInvoiceState,
  selectCompanies,
  selectCompaniesLoading,
  selectCompaniesError,
  selectDownloadingType,
  selectRegenerating,
  selectFilters,
  selectPagination,
} = invoiceFeature;

export const selectHasMore = createSelector(
  selectPagination,
  (pagination) => pagination.hasMore,
);
